import { memo } from 'react';
import { IoBusinessOutline } from 'react-icons/io5';
import { FloatingDoodle } from '../../components';
import { SPACESHIP_WHITE, DOODLE_SPACE, ROCKET, SPACE_WHITE } from '../../utils/constants/images';
import { useTheme } from '../../contexts/ThemeContext';
import { CentreSearchServiceProvider } from './contexts/CentreSearchServiceContext';
import CentreSearch from './components/CentreSearch';
import './index.css';

function HomePageContent() {
  const { darkMode } = useTheme();

  return (
    <div className="home-page">
      <div className="centre-search-container">
        <div className="centre-search-header">
          <IoBusinessOutline className="centre-search-icon" />
          <h1 className="centre-search-title">Centre Services</h1>
          <p className="centre-search-subtitle">Search and manage centres across BestStart</p>
        </div>

        <CentreSearch />
      </div>
      <FloatingDoodle source={darkMode ? SPACESHIP_WHITE : ROCKET} className="home-doodle home-doodle-boat" duration={5000} distance={14} />
      <FloatingDoodle source={darkMode ? SPACE_WHITE : DOODLE_SPACE} className="home-doodle home-doodle-space" duration={4000} distance={8} />
    </div>
  );
}

export default memo(() => (
  <CentreSearchServiceProvider>
    <HomePageContent />
  </CentreSearchServiceProvider>
));
